var Handlebars = require('/builds/lp-digital/backbee/toolbar-legacy/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"cloud-image-resize\"><i class=\"icon icon-margin\"></i></div>";
},"useData":true});